export default __webpack_public_path__ + "static/media/pic4.b674928d.jpg";